import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ArticleHeader from '../Article/ArticleHeader/ArticleHeader';
import Article from 'common/components/Article/Article';
import ArticleContent from '../Article/ArticleContent/ArticleContent';

export default class ArticleComponent extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { className, article, viewWithOnlyArticle } = this.props;

    const articleHeaderData = {
      name: article.title,
      date: article.publicationDate,
      logo: article.projectLogo,
      background: article.photo,
      category: article.pressRoomCategory.value
    };

    return (
      <div className={className}>
        <Article>
          <ArticleHeader
            {...articleHeaderData}
            viewWithOnlyArticle={viewWithOnlyArticle}
          />
          <ArticleContent>
            <div dangerouslySetInnerHTML={{ __html: article.text }} />
          </ArticleContent>
        </Article>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/ArtricleDetailPage/components/ArticleContentWrapper/ArticleContentWrapper.js